import { memo } from 'react';
import Images from 'src/App/Images';

export function RenderBitsIcon({ bits }) {
	const MemoisedIcon = memo(
		function PreRenderIcons({ bits }: { bits: any }) {
			if (bits > 10000) {
				return <img src={Images.Bits5} />;
			} else if (bits > 5000) {
				return <img src={Images.Bits4} />;
			} else if (bits > 1000) {
				return <img src={Images.Bits3} />;
			} else if (bits > 100) {
				return <img src={Images.Bits2} />;
			} else {
				return <img src={Images.Bits1} />;
			}
		},
		() => true,
	);

	return <MemoisedIcon bits={bits} />;
}
